import React from 'react';

const IconNoResults = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg
      width="31"
      height="31"
      viewBox="0 0 31 31"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="mr-4"
      {...props}
    >
      <path
        d="M15.5 0C6.94019 0 0 6.94269 0 15.5C0 24.0623 6.94019 31 15.5 31C24.0598 31 31 24.0623 31 15.5C31 6.94269 24.0598 0 15.5 0ZM15.5 6.875C16.9497 6.875 18.125 8.05025 18.125 9.5C18.125 10.9497 16.9497 12.125 15.5 12.125C14.0503 12.125 12.875 10.9497 12.875 9.5C12.875 8.05025 14.0503 6.875 15.5 6.875ZM19 22.75C19 23.1642 18.6642 23.5 18.25 23.5H12.75C12.3358 23.5 12 23.1642 12 22.75V21.25C12 20.8358 12.3358 20.5 12.75 20.5H13.5V16.5H12.75C12.3358 16.5 12 16.1642 12 15.75V14.25C12 13.8358 12.3358 13.5 12.75 13.5H16.75C17.1642 13.5 17.5 13.8358 17.5 14.25V20.5H18.25C18.6642 20.5 19 20.8358 19 21.25V22.75Z"
        fill="#FFAB00"
      />
    </svg>
  );
};

export default IconNoResults;
